import {
  ArrowRight, BadgeCheck, Bot, Building2, Calculator, Code2, FileBarChart, Globe, Headphones, HeartHandshake,
  IndianRupee, Magnet, MessageCircle, PenTool, Rocket, Search, ShieldCheck, Smartphone, Sparkles, Stethoscope,
  Target, TrendingUp, Users, Workflow, Wrench, Zap, Layers, Cloud, Database, LineChart,
} from "lucide-react";

const MAP = {
  ArrowRight, BadgeCheck, Bot, Building2, Calculator, Code2, FileBarChart, Globe, Headphones, HeartHandshake,
  IndianRupee, Magnet, MessageCircle, PenTool, Rocket, Search, ShieldCheck, Smartphone, Sparkles, Stethoscope,
  Target, TrendingUp, Users, Workflow, Wrench, Zap, Layers, Cloud, Database, LineChart,
};

export const DynIcon = ({ name, ...props }) => {
  const Icon = MAP[name] || Sparkles;
  return <Icon {...props} />;
};
